import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faBrain, faCalculator, faChartArea, faChartLine, faCircleQuestion, faDiceFive, faGifts, faHistory, faImages, faLanguage, faLinesLeaning, faLink, faListNumeric, faPencilRuler, faPersonArrowUpFromLine, faPersonCircleQuestion, faPersonDotsFromLine, faQuestion, faQuestionCircle, faSearch, faSheetPlastic, faSortNumericDown, faSquarePersonConfined, faTools, faTree, faVideo } from '@fortawesome/free-solid-svg-icons';
import './SmartDrill.css';
import smartdrillimage from '../../assets/pageimages/SmartDrill.webp';

function SmartDrillPreSchoolHome() {

  return (
    <MainLayout>
      <div className="p-4 bg-gray-100 min-h-screen mt-8">
        <h2 className='text-2xl font-bold text-center mb-4 text-gray-800'>Kids SMARTDrills</h2>
        
        {/* Centering and Responsive Image */}
        <div className="flex justify-center mb-6">
          <img src={smartdrillimage} alt="SmartDrill" style={{width: "200px", height:"auto"}}className="w-full max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md" />
        </div>

        {/* Grid Container with Mobile Padding */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mx-auto px-4 text-m">
          {/* Each Button Block */}
          {[
            { to: "/bookworld", icon: faBook, text: "Talking Books", bg: "bg-blue-400", iconColor: "text-yellow-200" },
            { to: "/orderflow-home", icon: faSheetPlastic, text: "Reusable Sheets", bg: "bg-green-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-fourlines", icon: faLinesLeaning, text: "4 Lines Writing", bg: "bg-orange-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-counting", icon: faListNumeric, text: "Counting Number", bg: "bg-red-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-numbername", icon: faSortNumericDown, text: "Number Name", bg: "bg-purple-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-numbertranslation", icon: faLanguage, text: "Number Translation", bg: "bg-teal-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-mtable", icon: faCalculator, text: "Multiplication Tables", bg: "bg-pink-400", iconColor: "text-yellow-200" },
            // { to: "/smartdrill-numberbonding", icon: faLink, text: "Number Bonding", bg: "bg-indigo-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-imagecloud", icon: faImages, text: "Practice Images", bg: "bg-pink-500", iconColor: "text-white" },
            // { to: "/smartdrill-videocloud", icon: faVideo, text: "Practice Videos", bg: "bg-orange-500", iconColor: "text-white" },
          ].map((item, index) => (
            <div key={index} className={`flex flex-col items-center p-4 border border-gray-300 rounded-lg ${item.bg} transition-transform transform hover:scale-105`}>
              <Link to={item.to} className="text-center mb-2">
                <FontAwesomeIcon icon={item.icon} className={`text-2xl mb-2 ${item.iconColor}`} /> 
              </Link>
              <div className="text-white text-lg font-medium text-center">
                {item.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

export default SmartDrillPreSchoolHome;
